import {ProductDetailFile} from './product-detail-file';

export class Product {

  id: number | null = null;
  token: string | null = null;
  nfrc_id: number | null = null;
  cgdb_id: number | null = null;
  name: string | null = null;
  marketing_name: string | null = null;
  type: string | null = null;
  subtype: string | null = null;
  short_description: string | null = null;
  deconstructable: boolean = false;
  manufacturer_name: string | null = null;
  acceptance: string | null = null;
  appearance: string | null = null;
  igdb_database_version: string | null = null;
  igsdb_version: string | null = null;

  private _cgdb_database_version = 0;
  get cgdb_database_version(): number {
    return this._cgdb_database_version;
  }

  set cgdb_database_version(value) {
    this._cgdb_database_version = Number(value);
  }

  data_file_name: string | null = null;
  data_file_available: boolean = false;

  // physical_properties
  is_specular: boolean = false;
  spectral_data: Array<object> = [];
  thickness: string | null = null;
  tir_front: number | null = null;
  tir_back: number | null = null;
  emissivity_front: number | null = null;
  emissivity_back: number | null = null;
  conductivity: number | null = null;
  coated_side: string | null = null;
  coating_name: string | null = null;
  permeability_factor: string | null = null;

  // integrated results summary
  tf_sol: number | null = null;
  rf_sol: number | null = null;
  rb_sol: number | null = null;

  tf_vis: number | null = null;
  rf_vis: number | null = null;
  rb_vis: number | null = null;

  tf_ciex: number | null = null;
  tf_ciey: number | null = null;
  tf_ciez: number | null = null;

  tf_r: number | null = null;
  tf_g: number | null = null;
  tf_b: number | null = null;

  rf_ciex: number | null = null;
  rf_ciey: number | null = null;
  rf_ciez: number | null = null;

  rf_r: number | null = null;
  rf_g: number | null = null;
  rf_b: number | null = null;

  rb_ciex: number | null = null;
  rb_ciey: number | null = null;
  rb_ciez: number | null = null;

  rb_r: number | null = null;
  rb_g: number | null = null;
  rb_b: number | null = null;

  tdw: number | null = null;
  tuv: number | null = null;
  tspf: number | null = null;
  tkr: number | null = null;

  get num_product_detail_files(): number {
    if (this.product_detail_files) {
      return this.product_detail_files.length;
    }
    return 0;
  }

  product_detail_files: Array<ProductDetailFile> = [];

  constructor(initialValues: Partial<Product>) {
    Object.assign(this, initialValues);
    if (initialValues.product_detail_files) {
      this.product_detail_files = initialValues.product_detail_files.map(data => new ProductDetailFile(data));
    }
  }

  set physical_properties(obj: any) {
    Object.assign(this, obj);
  }

  set optical_data(obj: any) {
    Object.assign(this, obj);
  }

  set integrated_spectral_averages_summaries(obj: any) {
    /*
      DMcQ: We changed the API to return *all* integrated results for each product,
      so the client will have to pick out the right one to display in the table.
      Making this user-defined would involve setting up a 'standard' selector in the UI.
      For now I'm going to hard-code to the one and only standard we have.
    */
    // get first item in array.
    let results_summary = null;
    for (const summary of obj) {
      if (summary.calculation_standard === 'NFRC') {
        this.integrated_spectral_averages_summary = summary;
      }
    }
    Object.assign(this, results_summary);
  }

  set integrated_spectral_averages_summary(results_summary: any) {
    Object.assign(this, results_summary);
  }

}
